import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import PlayCircleOutlineIcon from "@material-ui/icons/PlayCircleOutline";
import style from "./style.module.css";
import styleHover from "../PlaylistItem/style.module.css";

import { useTranslate } from "../../utils/utils";
import { MULTITENANT_CONSTANTS, TENANT } from "../../../../Resources/Multitenant/tenantConstants";
import { actionTypeContainer } from "../../../../Utils/utils";
import FavButton from "../FavButton/FavButton";

const ActionButtons = ({ data, trigger, event, actionLink = true, goToLink }) => {
  const { id, canFav, isFav, video, controller } = data;
  const videoUrl = video?.url;
  const videoType = video?.type;
  const t = useTranslate();
  const dragStateRef = useRef({
    isPointerDown: false,
    moved: false,
    startX: 0,
    startY: 0,
  });

  useEffect(() => {
    const handlePointerMove = (event) => {
      const state = dragStateRef.current;
      if (!state.isPointerDown) {
        return;
      }
      const deltaX = Math.abs(event.clientX - state.startX);
      const deltaY = Math.abs(event.clientY - state.startY);
      if (Math.max(deltaX, deltaY) > 5) {
        state.moved = true;
      }
    };

    const handlePointerUp = () => {
      const state = dragStateRef.current;
      state.isPointerDown = false;
      state.startX = 0;
      state.startY = 0;
      requestAnimationFrame(() => {
        state.moved = false;
      });
    };

    window.addEventListener("pointermove", handlePointerMove);
    window.addEventListener("pointerup", handlePointerUp);
    window.addEventListener("pointercancel", handlePointerUp);

    return () => {
      window.removeEventListener("pointermove", handlePointerMove);
      window.removeEventListener("pointerup", handlePointerUp);
      window.removeEventListener("pointercancel", handlePointerUp);
    };
  }, []);

  const handlePointerDown = (event) => {
    const state = dragStateRef.current;
    state.isPointerDown = true;
    state.moved = false;
    state.startX = event.clientX;
    state.startY = event.clientY;
  };

  const suppressIfDragged = (event) => {
    if (dragStateRef.current.moved) {
      event.preventDefault();
      event.stopPropagation();
      dragStateRef.current.moved = false;
      return true;
    }
    return false;
  };

  const showActionLink = () => {
    if (actionLink) {
      return (
        <Link
          to={{
            pathname: actionTypeContainer(trigger).ROUTE + "/" + id,
            state: {
              url: videoUrl,
              type: videoType,
              id: id,
            },
          }}
          aria-label={t("global.button.go.to.player")}
          onPointerDown={handlePointerDown}
          onClick={(event) => suppressIfDragged(event)}
          onDragStart={(event) => event.preventDefault()}
        >
          <PlayCircleOutlineIcon id={style.playIcon} />
        </Link>
      );
    } else {
      return (
        <PlayCircleOutlineIcon
          id={style.playIcon}
          onPointerDown={handlePointerDown}
          onClick={(event) => {
            if (suppressIfDragged(event)) {
              return;
            }
            goToLink();
          }}
        />
      );
    }
  };
  return (
    <section
      className={`
            ${styleHover.playFavContainer__top}
            ${MULTITENANT_CONSTANTS[TENANT].ImageWithText ? style.playFavContainer : style.playFavContainer__top}`}
    >
      {showActionLink()}
      {canFav && (
        <FavButton
          className={style.favIcon}
          controller={controller}
          events={event}
          id={id}
          isFavorite={isFav ?? false}
          isPlaylist={true}
        />
      )}
    </section>
  );
};

ActionButtons.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.number.isRequired,
    canFav: PropTypes.bool,
    isFav: PropTypes.bool,
  }).isRequired,
  trigger: PropTypes.string.isRequired,
};

export default ActionButtons;
